import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../assets/logo-black.png';

export default function Navbar({ goToHome, goToBlogs, currentPage }) {
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setSolid(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, section) => {
    e.preventDefault();
    
    if (section === 'blogs') {
      goToBlogs();
    } else if (section === 'home') {
      goToHome();
    } else {
      // Si está en blogs, primero va a home y luego a la sección
      if (currentPage === 'blogs') {
        goToHome(section);
      } else {
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <nav className={`nav-all ${solid ? 'solid' : ''}`}>
      <div className="nav-logo">
        <img 
          src={logo} 
          alt="Cozobi Agro" 
          onClick={(e) => handleNavClick(e, 'home')}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <ul className="nav-links">
        <li><a href="#inicio" onClick={(e) => handleNavClick(e, 'inicio')}>INICIO</a></li>
        <li><a href="#productos" onClick={(e) => handleNavClick(e, 'productos')}>PRODUCTOS</a></li>
        <li><a href="#nosotros" onClick={(e) => handleNavClick(e, 'nosotros')}>NOSOTROS</a></li>
        <li><a href="#contacto" onClick={(e) => handleNavClick(e, 'contacto')}>CONTACTO</a></li>
        <li><a href="#blogs" onClick={(e) => handleNavClick(e, 'blogs')}>BLOGS</a></li>
      </ul>
    </nav>
  );
}